<template>
  <v-dialog :value="value" @input="close" max-width="600px">
    <v-card>
      <!-- Title -->
      <v-card-title>
        <h3 v-if="item">{{ $t("accounts.mainDialog.edit.title") }}</h3>
        <h3 v-else>{{ $t("accounts.mainDialog.add.title") }}</h3>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <!-- Name -->
            <v-col cols="12" class="mt-12">
              <v-text-field
                outlined
                :rules="requiredRules"
                :label="$t('accounts.labels.name')"
                maxlength="255"
                v-model="form.name"
              />
            </v-col>

            <!-- Type -->
            <v-col cols="12">
              <v-select
                hide-details
                :rules="requiredRules"
                outlined
                :label="$t('accounts.labels.type')"
                :items="$t('constants.accountTypes.list')"
                v-model="form.type"
              />
            </v-col>

            <!-- Group (if type = brand) -->
            <v-col cols="12" v-if="form.type === 'BRAND'">
              <SelectAccount
                label="accounts.labels.parent"
                account-type="GROUP"
                @input="onInputParent"
                :value="form.parent"
              />
            </v-col>

            <!-- FM Referent -->
            <v-col cols="12">
              <SelectFMReferent
                @input="onInputFMReferent"
                :value="form.fm_referents"
                :isMultiple="true"
              />
            </v-col>

            <!-- Enabled -->
            <v-col cols="12">
              <v-switch
                v-model="form.enabled"
                :label="$t('accounts.labels.enabled')"
              />
            </v-col>

            <v-col cols="12">
              <AlertBar />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <ButtonBarFormDialog
          class="mx-3"
          :is-loading-btn-save="isLoadingBtn.btnSave"
          @submit="customSubmit"
          @cancel="close(false)"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogMixin from "@/mixins/dialog";
import formRules from "@/mixins/formRules";

export default {
  name: "AccountMainDialog",

  mixins: [dialogMixin, formRules],

  components: {
    SelectFMReferent: () =>
      import("@/components/Common/Inputs/SelectFMReferent"),
    SelectAccount: () => import("@/components/Common/Inputs/SelectAccount"),
    AlertBar: () => import("@/components/Common/Bars/AlertBar"),
    ButtonBarFormDialog: () =>
      import("@/components/Common/Buttons/ButtonBarFormDialog"),
  },

  data() {
    return {
      isLoadingBtn: { btnSave: false },

      defaultForm: {
        name: "",
        type: "BRAND",
        parent: null,
        fm_referents: [
          { id: this.$session.get("id"), person: this.$session.get("person") },
        ],
        enabled: true,
        settings: {
          website: "",
          myproductimpact_path: "",
          myproductimpact_redirection_url: "",
          color: "",
        },
      },
    };
  },

  methods: {
    customSubmit() {
      if (this.$refs.form.validate()) {
        this.isLoadingBtn.btnSave = true;
        this.shortcutFormObjects(["fm_referents", "parent"]);
        if (this.item) this.submitEdit();
        else this.submitAdd();
      }
    },

    submitAdd() {
      this.$http
        .post(`/accounts`, this.form, {
          headers: { Authorization: "Bearer " + this.$session.get("jwt") },
        })
        .then((res) => {
          this.$store.commit(
            "toast/showSuccess",
            this.$t("accounts.mainDialog.add.success")
          );
          this.close(true);
        })
        .catch((err) => {
          this.$store.commit("alert/showErrorAxios", err);
        })
        .finally(() => {
          this.isLoadingBtn.btnSave = false;
        });
    },

    submitEdit() {
      this.$http
        .put(`/accounts/${this.item.id}`, this.form, {
          headers: { Authorization: "Bearer " + this.$session.get("jwt") },
        })
        .then((res) => {
          this.$store.commit(
            "toast/showSuccess",
            this.$t("accounts.mainDialog.edit.success")
          );
          this.close(true);
        })
        .catch((err) => {
          this.$store.commit("alert/showErrorAxios", err);
        })
        .finally(() => {
          this.isLoadingBtn.btnSave = false;
        });
    },

    onInputParent(val) {
      this.form.parent = val;
    },

    onInputFMReferent(val) {
      this.form.fm_referents = val;
    },
  },
};
</script>

<style scoped></style>
